<!-- Session problems (expired session, masquerade changed in another tab) are
     surfaced outside the bootstrap gate so they remain visible at all times. -->
<risr-session-banner></risr-session-banner>

@if (bootstraped()) {
    <!-- Skip navigation to main content -->
    <button type="button" class="btn kz-skip-navigation" (click)="skipToContent()" i18n>Skip to content</button>
    <main-template-directive>
        <router-outlet></router-outlet>
    </main-template-directive>

    <!-- Global AI assistant (gated by the "ai-assistant" feature flag — which
         superadmins bypass — and the user's aiassistant.use permission;
         renders only when a risrai backend URL is configured) -->
    @if (showAiAssistant()) {
        <risr-ai-assistant-host [context]="aiContext()"></risr-ai-assistant-host>
    }
}
